<template>
  <div v-cloak>
    <Loader v-if="loader.data" />
    <div v-else class="container-fluid px-0">
      <div class="d-flex flex-column flex-lg-row">
        <div class="order-2 order-lg-1 col-lg-7 px-0 bg-thanks">
          <div class="text-left d-none d-lg-block">
            <router-link to="/">
              <img
                class="app__logo"
                src="@/assets/images/logo.svg"
                alt="Logo greenpeace"
              />
            </router-link>
          </div>

          <Content />
        </div>
        <div class="order-1 order-lg-1 col-lg-5 px-0" id="wolf-bg">
          <div class="text-right d-lg-none">
            <router-link to="/">
              <img
                class="app__logo-s"
                src="@/assets/images/logo.svg"
                alt="Logo greenpeace"
              />
            </router-link>
          </div>
          <img
            src="../assets/images/wolf/wolf_bg.jpg"
            class="sidewolf d-none d-lg-block"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "./Content.vue";
import Loader from "./Loader.vue";

export default {
  name: "Page",
  data() {
    return {
      contrastView: false,
      fontRegularView: true,
      fontMiddleView: false,
      fontBigView: false,
      mainPage: true,
      showAdditionalNav: false,
    };
  },
  components: {
    Content,
    Loader,
  },

  inject: ["loader"],

  created() {},
};
</script>
